import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

class ChatService {
    async sendMessage(message) {
        try {
            const response = await axios.post(`${API_URL}/chat`, { message });
            return response.data;
        } catch (error) {
            console.error('Chat service error:', error);
            throw error;
        }
    }
}

export default new ChatService();
